/* © Facilogi. See COPYRIGHT file for full copyright & licensing details. */

/* L'ETAGE DE TUNNEL D'UN ARTICLE ( Fred, 22/10/2026 ), comme le Desktop
   ( `src/Web/Views/Newsletter/Automatic/Stage.ts` ).

   Le back n'a pas de champ « etage » : il se lit sur les TAGS de l'article
   ( « TOFU », « MOFU », « BOFU », ou « Haut / Milieu / Bas de tunnel » ).

   ⚠️ Les statistiques de la newsletter ne renvoient pas encore les tags, et la
   Console n'a pas de route pour lire un article seul : tant que le back n'ajoute
   pas `tags` au classement des articles ( `posts-stats` ), tout est « sans etage »
   ici, sauf en demonstration. */

export type FunnelStage = "top" | "middle" | "bottom" | "none";

export const FUNNEL_STAGES: FunnelStage[] = [ "top", "middle", "bottom", "none" ];

/* Palette validee ( dataviz, `validate_palette.js`, clair et sombre ), fixee par
   etage : un filtre ne repeint jamais les bulles restantes. */
export function StageColor( stage: FunnelStage, dark: boolean ): string {
    const light: { [ key: string ]: string } = {
        top: "#2a78d6", middle: "#eb6834", bottom: "#1baf7a", none: "#a3a29d"
    };
    const night: { [ key: string ]: string } = {
        top: "#3987e5", middle: "#d95926", bottom: "#199e70", none: "#73726c"
    };

    return ( dark ? night : light )[ stage ];
}

function plain( value: string ): string {
    return value
        .toLowerCase()
        .normalize( "NFD" )
        .replace( /[̀-ͯ]/g, "" )
        .trim();
}

/* Le nom d'un tag -> son etage ; `null` si le tag ne parle pas d'etage. */
export function StageOfTag( name: string ): FunnelStage | null {
    const tag = plain( name );

    if( tag === "tofu" || tag.indexOf( "haut de tunnel" ) >= 0 )
        return "top";

    if( tag === "mofu" || tag.indexOf( "milieu de tunnel" ) >= 0 )
        return "middle";

    if( tag === "bofu" || tag.indexOf( "bas de tunnel" ) >= 0 )
        return "bottom";

    return null;
}

/* L'etage de chaque article, lu sur les `tags` du classement quand le back les
   donne. */
export function StagesOfPosts( posts: { id: number }[] ): { [ id: number ]: FunnelStage } {
    const stages: { [ id: number ]: FunnelStage } = {};

    posts.forEach( ( post: any ): void => {
        stages[ post.id ] = "none";

        const tags = Array.isArray( post.tags ) ? post.tags : [];

        for( const tag of tags ) {
            const stage = StageOfTag( String( ( tag && tag.name ) || tag || "" ) );

            if( stage !== null ) {
                stages[ post.id ] = stage;
                break;
            }
        }
    } );

    return stages;
}
